import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment-timezone';

import InviteFriendModal from '../../../../components/InviteFriendModal';

import Spinner from '../../../../../../components/Spinner';
import Segment from '../../../../../../components/Segment';

import './JoinSessionPage.scss';

import HeroImage1 from './images/OH-Header-3.jpg';
import FooterImage1 from './images/Depositphotos_53801085.jpg';
import CancelImage from './images/cancel.png';

import ZoomInstructions1 from './images/zoom-instructions-1.jpg';
import ZoomInstructions2 from './images/zoom-instructions-2.jpg';
import ZoomInstructions3 from './images/zoom-instructions-3.jpg';

import FacebookLogoImage from './images/logo-facebook.png';
import EmailImage from './images/mail-logo.png';

import WeChatLogo from './images/wechat-logo.png';
import QRImage from './images/qr-code.png';

import { facebookShare } from 'components/Utils';

import MattHeadshot from './images/matt_headshot.png'; // TEST IMAGE

const segment = new Segment();

const monthNames = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];
// eslint-disable-next-line
const EmailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

class ViewOfficeHours extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      inviteFriendModalIsOpen: false,
      dataLoaded: false,
      meetingReady: false,
      meetingOver: false,
    };

    this.setInviteModal = this.setInviteModal.bind(this);
    this.facebookShareThisPage = this.facebookShareThisPage.bind(this);
  }

  componentDidMount () {
    segment.page();

    // Set up a check to see if the session data has been loaded and the link for the session should be displayed
    this.timeChecker = setInterval(() => {
      if (this.props.SessionData.loading === false) {
        if (!this.state.dataLoaded) this.setState({ dataLoaded: true });
        let SessionEntry = this.props.SessionData.getOfficeSessions.find(x => x.id === parseInt(this.props.routeParams.id, 10));
        if (typeof SessionEntry !== 'undefined') {
          if (moment(SessionEntry.start_time).diff(moment(), 'minutes') < 31) {
            this.setState({ meetingReady: true });

            if (moment(SessionEntry.start_time).diff(moment(), 'minutes') < -60) {
              this.setState({ meetingOver: true });
              clearInterval(this.timeChecker);
            }
          }
        } else {
          clearInterval(this.timeChecker);
        }
      }
    }, 500);
  }

  componentWillUnmount () {
    // remove the check from componentDidMount()
    clearInterval(this.timeChecker);
  }

  setInviteModal (val) {
    return () => this.setState({
      inviteFriendModalIsOpen: val,
    });
  }

  facebookShareThisPage (evt) {
    evt.preventDefault();

    segment.track('Initiated a facebook share', {
      page: window.location
    });

    return facebookShare();
  }

  renderSession () {
    if (this.state.dataLoaded) {
      const SessionEntry = this.props.SessionData.getOfficeSessions.find(x => x.id === parseInt(this.props.routeParams.id, 10));
      if (typeof SessionEntry !== 'undefined') {
        const StartDate = moment(SessionEntry.start_time).tz('America/New_York');
        const TimeZone = 'EST';

        return (
          <div className='OfficeHour__WholeWrap'>
            <h5 className='OfficeHour__TimeHeader'>
              {StartDate.format('MMM. DD | hh:mm a')} {TimeZone}
            </h5>
            <h3>{SessionEntry.advisor_bio}</h3>
            <div className='row'>
              <div className='col-3'>
                <img src={IMAGECACHELINK + '/' + IMAGESTAGE + '/300x300/' + SessionEntry.host.photo} className='OfficeHour__AdvisorImage' />
                <h5 className='OfficeHour__HostName'>{SessionEntry.host.first_name + ' ' + SessionEntry.host.last_name}</h5>
                <p className='OfficeHour__AdvisorBio'>{SessionEntry.title}</p>
                <p>{SessionEntry.company_1}</p>
                <p>{SessionEntry.company_2}</p>
              </div>
              <div className='col-9 text-left'>
                <p><br /></p>
                <div dangerouslySetInnerHTML={{ __html:SessionEntry.host.advisor_info.advisor_summary_intro && SessionEntry.host.advisor_info.advisor_summary_intro.replace(/(?:\r\n|\r|\n)/g, '<br />') }} />
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                {SessionEntry.zoom_meeting_id ? (
                  this.state.meetingReady
                  ? (this.state.meetingOver
                    ? (
                      <div>
                        <p className='font-italic font-weight-bold'>This Meeting is Over</p>
                      </div>
                    ) : (
                      <div>
                        <a className='button' href={'https://zoom.us/j/' + SessionEntry.zoom_meeting_id} target='_blank'>
                          Click here to join this tea time!
                        </a>
                        <div className='OfficeHour__ZoomInstructions'>
                          <h5>Instructions:</h5>
                          <ol>
                            <li>Click the link above or the Zoom link on your Google Calendar Invite</li>
                            <li>When you are redirected to the Zoom website, click “Open Zoom Meetings”, and then selected “download”. The app will begin to download on your computer. <br /><img src={ZoomInstructions1} /></li>
                            <li>Once the app is installed, click it and type in your name to create an account.<br /><img src={ZoomInstructions2} /></li>
                            <li>Select “allow video”, “allow audio”, and “Join Audio Conference by Computer”<br /><img src={ZoomInstructions3} /></li>
                            <li>Once session begins, you may start speaking to the advisor.</li>
                          </ol>
                        </div>
                      </div>
                    )
                  ) : (
                    <p className='disabled'>
                      <br />
                      <b>You will see a link to join 30 minutes before the session. Stay tuned!</b>
                    </p>
                  )
                ) : (
                  <p>Tea Time is being prepared</p>
                )}
              </div>
            </div>
            <br />
            {/* <p style={{fontWeight: '600', color: '#193865'}}>Enjoyed this Tea Time?</p>
            <a href='/signup/virtualteatime' className='button button--hollow'>
              View Other Tea Times
            </a> */}
          </div>
        );
      } else {
        return (
          <div className='OfficeHour__WholeWrap'>
            <h3>This Tea Time session does not exist</h3>
            <br />
            <p style={{ fontWeight: '600', color: '#193865' }}>Where can I find others?</p>
            <a href='/signup/virtualteatime' className='button button--hollow'>
              View Other Tea Times
            </a>
          </div>
        );
      }
    }
    return <Spinner />;
  }

  render () {
    console.log(this.props);
    return (
      <div style={{ background: '#f0f1f3', position: 'relative' }}>
        <InviteFriendModal isOpen={this.state.inviteFriendModalIsOpen} onDismiss={this.setInviteModal(false)} sendEmailInvite={this.props.SendEmailInvite} />
        <div className='HeroSection HeroSection--Small'>
          <div className='HeroSection__BackGroundWrap'>
            <img src={HeroImage1} />
          </div>
          <div className='HeroSection__ContentWrap'>
            <div className='container'>
              <div className='row'>
                <div className='col-lg-8 col-md-10'>
                  <h1 className='heading-1'>Tea Time</h1>
                  <p className='subhead-1'>
                    Speak with successful industry professionals at our FREE Tea Time, and find out how you can get your big break.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='OfficeHours__Wrapper' ref='OfficeHourAnchor'>
          <div className='container'>
            <div className='row'>
              {this.renderSession()}
            </div>
          </div>
        </div>
        <div className='FooterImage'>
          <div className='FooterImage__BackGroundWrap'>
            <img src={FooterImage1} />
          </div>
          <div className='FooterImage__ContentWrap'>
            <div className='container'>
              <div className='FooterImage__InternalWrap'>
                <p className='FooterImage__MinorTitle'>Paragon One grew out of an invite-only mentor network started at MIT 10 years ago. We offer personalized career and entrepreneurship coaching, which includes mentoring, exclusive online courses, and an active peer network.</p>
                <a href='https://www.paragonone.com/' className='button button--trim'>Learn more about Paragon One</a>
              </div>
            </div>
          </div>
        </div>
        <footer className='OfficeHours'>
          <div className='container'>
            <div className='row'>
              <div className='col-sm'>
                <h5>Contact Us</h5>
                <p>info@paragonone.com<br />1-888-527-6888</p>
              </div>
              <div className='col-sm'>
                <div className='FooterImage__InternalWrap'>
                  <p className='SegmentSubTitle'>Be someone's career hero!<br />Share Office Hours with a friend:</p>
                  <div className='row SocialIntergrations'>
                    <a href='#' onClick={this.facebookShareThisPage}>
                      <img style={{ padding: '1px 14px 0px 11px' }} src={FacebookLogoImage} />
                    </a>
                    <a style={{ cursor: 'pointer' }} onClick={this.setInviteModal(true)}>
                      <img src={EmailImage} style={{ height: '60px' }} />
                    </a>
                  </div>
                </div>
              </div>
              <div className='col-sm'>
                <img style={{ height: '75px' }} src={QRImage} />
                <img style={{ height: '45px', marginTop: '15px' }} src={WeChatLogo} />
              </div>
            </div>
            <div className='row'>
              <p className='copy'>&copy; 2017 Paragon One, All Rights Reserved</p>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default ViewOfficeHours;



// WEBPACK FOOTER //
// ./src/routes/officehours/routes/JoinPage/components/JoinSessionPage/index.js